
export default (payload, next) => {
    return  next(payload);
};